import {MEDIA_TYPE_TOGGLE_KEYBOARD_KEYS, MediaTypeToggleNavigationDirection} from './social-media-media-type-toggle.types';

export function getAdjacentOptionIndex(currentIndex: number, direction: MediaTypeToggleNavigationDirection, optionCount: number): number {
  if (direction === MediaTypeToggleNavigationDirection.NEXT) {
    return (currentIndex + 1) % optionCount;
  }

  return (currentIndex - 1 + optionCount) % optionCount;
}

export function getNavigationDirectionForKey(key: string): MediaTypeToggleNavigationDirection | null {
  if (key === MEDIA_TYPE_TOGGLE_KEYBOARD_KEYS.ARROW_RIGHT || key === MEDIA_TYPE_TOGGLE_KEYBOARD_KEYS.ARROW_DOWN) {
    return MediaTypeToggleNavigationDirection.NEXT;
  }

  if (key === MEDIA_TYPE_TOGGLE_KEYBOARD_KEYS.ARROW_LEFT || key === MEDIA_TYPE_TOGGLE_KEYBOARD_KEYS.ARROW_UP) {
    return MediaTypeToggleNavigationDirection.PREVIOUS;
  }

  return null;
}
